import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface IDialogModalImageCaptureData {
  idTrade: string;
}

@Component({
  selector: 'app-modal-image-capture',
  templateUrl: './modal-image-capture.component.html',
  styleUrls: ['./modal-image-capture.component.sass'],
  encapsulation: ViewEncapsulation.None,
})
export class ModalImageCaptureComponent implements AfterViewInit {
  @ViewChild('video') public video: ElementRef;
  @ViewChild('canvas') public canvas: ElementRef;

  devices: any[];
  deviceSelected: any;
  showPreview!: boolean;
  snapPhoto!: any;

  constructor(
    private dialogRef: MatDialogRef<ModalImageCaptureComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDialogModalImageCaptureData
  ) {}

  ngAfterViewInit(): void {
    this.startCameraPreview();
  }

  startCameraPreview() {
    this.showPreview = false;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
        this.video.nativeElement.srcObject = stream;
        this.video.nativeElement.autofocus = true;
        this.video.nativeElement.play();
      });
    }
  }

  public capture() {
    this.canvas.nativeElement.getContext('2d').drawImage(this.video.nativeElement, 0, 0, 640, 480);
    this.showPreview = true;
    this.snapPhoto = this.canvas.nativeElement.toDataURL('image/png');
    this._closeStream();
  }

  public doSave() {
    this.dialogRef.close(this.snapPhoto);
  }

  private _closeStream() {
    this.video.nativeElement.pause();
    const stream = this.video.nativeElement.srcObject;
    const tracks = stream.getTracks();

    tracks.forEach((track) => {
      track.stop();
    });
    this.video.nativeElement.src = '';
    this.video.nativeElement.srcObject = null;
  }
}
